import { Time } from '@angular/common';
import { inject } from '@angular/core';
import { DateSelectionModelChange } from '@angular/material/datepicker';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { pipe, switchMap, tap, Observable, combineLatest, map, withLatestFrom, filter } from 'rxjs';
import { StepsMenuComponent } from '../../create-questionnaire-page/component/steps-menu/steps-menu.component';
import { DefinitionsStyle } from '../../../models/definitionsStyle.model';
import { EStatus } from '../../../models/EnumStatus';
import { Question } from '../../../models/question.model';
import { Questionnaire } from '../../../models/questionnaire.model';
import { QuestionnaireCategory } from '../../../models/questionnaireCategory.model';
import { QuestionType } from '../../../models/questionType.model';
import { Step } from '../../../models/step.model';
import { User } from '../../../models/user.model';
// import { Step } from '../features/create-questionnaire/models/step.model';
import { QuestionnaireApiService } from '../../../services/questionnaire-api.service';
import { CollectionQuestionApiService } from '../services/collection-question-api.service';

export interface CollectionQuestionsState {
  readonly collection: Question[];
  readonly loading: boolean;
  error?: string;
}

export class CollectionQuestionsStore extends ComponentStore<CollectionQuestionsState> {

  #collectionQuestionsApiService = inject(CollectionQuestionApiService)

  constructor() {
    super({
      collection: [],
      loading: false
    });
  }
  readonly collection$ = this.select(({ collection }) => collection);

  readonly fetchCollectionQuestion = this.effect<void>(
    pipe(
      tap(() => this.patchState({ loading: true })),
      switchMap(() =>
        this.#collectionQuestionsApiService.getAll().pipe(
          tapResponse(
            (collection) => this.patchState({ collection, loading: false }),
            (error: Error) =>
              this.patchState({ error: error?.message, loading: false })
          )
        )
      )
    )
  );
  readonly remove = this.effect<number>(
    pipe(
      tap((i) => this.patchState({ loading: true })),
      switchMap((i) =>
        this.#collectionQuestionsApiService.deleteById(i).pipe(
          tapResponse(
            () => {
              this.fetchCollectionQuestion();
              this.patchState({ loading: false })
            },
            (error: Error) =>
              this.patchState({ error: error?.message, loading: false })
          )
        )
      )
    )
  );
  readonly update = this.effect<Question>(
    pipe(
      tap((q) => this.patchState({ loading: true })),
      switchMap((q) =>
        this.#collectionQuestionsApiService.update(q).pipe(
          tapResponse(
            () => {
              this.fetchCollectionQuestion();
              this.patchState({ loading: false })
            },
            (error: Error) =>
              this.patchState({ error: error?.message, loading: false })
          )
        )
      )
    )
  );

  // readonly deleteReminder = this.effect<number>(
  //   pipe(
  //     switchMap((id) =>
  //       this.#reminderService.deleteReminderById(id).pipe(
  //         tap((x) => this.getReminders()
  //         )
  //       )
  //     )
  //   )
  // );
}